// Preço pode chegar como número ou texto ("R$ 12,90", "12.9"); tudo vira número antes da conta.
export const parsePreco = (preco) => {
  if (typeof preco === "number") return preco;
  if (typeof preco === "string") {
    const limpo = preco.replace(/[R$\s]/g, "").replace(",", ".");
    return parseFloat(limpo) || 0;
  }
  return 0;
};

const formatador = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const formatarPreco = (preco) => formatador.format(parsePreco(preco));
